var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 533.5 544.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M533.5 278.4c0-17.4-1.4-34-4.1-50.3H272v95h146.9c-6.3 34-25 62.8-53.3 82v68h86.1c50.4-46.5 81.8-114.8 81.8-194.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M272 544.3c71.8 0 132-23.8 176-64.9l-86.1-68c-23.8 16-54.3 25.5-89.9 25.5-69 0-127.5-46.6-148.4-109.3H36.1v68.9C79.3 480.3 169.5 544.3 272 544.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M123.6 327.6c-10.8-32-10.8-66.4 0-98.4v-68.9H36.1c-35.7 71.4-35.7 154.9 0 226.3l87.5-68.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M272 214.8c38.9-.6 76.2 14.1 104.6 40.9l77.8-77.8C411.3 109.5 344 79.5 272 80.1 169.5 80.1 79.3 144 36.1 226.3l87.5 68.9c20.9-62.7 79.4-109.3 148.4-109.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M36.1 226.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.c3455459b8de06cafe2a8fc157895d3d.svg";
export { ForwardRef as ReactComponent };